import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

export const RegisterTopFields = ({ role, form, set, vatState, validateVat }) => (
  <>
    {role === "bedrijf" && (
      <div className="border border-orange-200 bg-orange-50/60 rounded-sm p-3 space-y-2" data-testid="vat-block">
        <Label className="text-xs font-bold text-slate-700">BTW-nummer (verplicht)</Label>
        <div className="flex gap-2">
          <Input data-testid="btw-input" required value={form.btw_nummer} onChange={set("btw_nummer")}
            className="rounded-sm border-slate-300 bg-white" placeholder="bv. NL123456789B01 of BE0123456789" />
          <Button type="button" data-testid="btw-validate-btn" onClick={validateVat} disabled={vatState.checking}
            className="bg-slate-900 hover:bg-slate-800 text-white rounded-sm font-bold shrink-0">
            {vatState.checking ? <Loader2 className="w-4 h-4 animate-spin" /> : "Controleer"}
          </Button>
        </div>
        {vatState.result && (
          <div data-testid="vat-result"
            className={`flex items-start gap-1.5 text-xs font-medium ${vatState.result.geldig ? "text-green-700" : vatState.result.status === "onbekend" ? "text-amber-700" : "text-red-600"}`}>
            {vatState.result.geldig
              ? <CheckCircle2 className="w-3.5 h-3.5 mt-0.5 shrink-0" />
              : <AlertCircle className="w-3.5 h-3.5 mt-0.5 shrink-0" />}
            <span>{vatState.result.boodschap}</span>
          </div>
        )}
        <p className="text-[11px] text-slate-500">We controleren je BTW-nummer via de officiële VIES-database en vullen je bedrijfsgegevens automatisch in.</p>
      </div>
    )}
    <div>
      <Label className="text-xs font-bold text-slate-700">
        {role === "bedrijf" ? "Contactpersoon" : "Volledige naam"}
      </Label>
      <Input data-testid="name-input" required value={form.name} onChange={set("name")}
        className="rounded-sm border-slate-300 focus:ring-2 focus:ring-orange-500" placeholder="Jan Jansen" />
    </div>
    {role === "bedrijf" && (
      <div>
        <Label className="text-xs font-bold text-slate-700">Bedrijfsnaam</Label>
        <Input data-testid="bedrijfsnaam-input" value={form.bedrijfsnaam} onChange={set("bedrijfsnaam")}
          className="rounded-sm border-slate-300" placeholder="Bouwbedrijf BV" />
      </div>
    )}
    {role === "bedrijf" && (
      <div>
        <Label className="text-xs font-bold text-slate-700">Website</Label>
        <Input data-testid="website-input" type="url" value={form.website} onChange={set("website")}
          className="rounded-sm border-slate-300" placeholder="https://www.jouwbedrijf.be" />
      </div>
    )}
    {role === "particulier" && (
      <div>
        <Label className="text-xs font-bold text-slate-700">Adres (verplicht)</Label>
        <Input data-testid="adres-input" required value={form.adres} onChange={set("adres")}
          className="rounded-sm border-slate-300" placeholder="Straat 1, 1234 AB Plaats" />
      </div>
    )}
  </>
);
